import React from 'react';
import RecipeCard from './RecipeCard';
import { BookOpen, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button, EmptyState } from '../common';

export default function RecipeList({ recipes }) {
  const navigate = useNavigate();

  if (!recipes || recipes.length === 0) {
    return (
      <EmptyState
        icon={<BookOpen size={48} className="text-gray-400 dark:text-night-muted" aria-hidden="true" />}
        title="No recipes yet"
        description="Import a recipe from the web or add one manually to get started."
        action={
          <div className="flex gap-2 justify-center flex-wrap">
            <Button onClick={() => navigate('/import')}>Import from URL</Button>
            <Button variant="secondary" onClick={() => navigate('/submit')}>
              <Plus size={18} aria-hidden="true" />
              Add Manually
            </Button>
          </div>
        }
      />
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3">
      {recipes.map((recipe) => (
        <RecipeCard key={recipe.id} recipe={recipe} />
      ))}
    </div>
  );
}
